import { createMutation } from '../api/mutation'

export const useUploadMediaAssets = createMutation({
    url: '/upload-media',
    method: 'POST',
    // Don't set Content-Type for FormData - browser sets it automatically with boundary
})

export const useUpdateMediaAssets = createMutation({
    url: '/media-assets',
    method: 'PATCH',
    // Don't set Content-Type for FormData - browser sets it automatically with boundary
})

export const useDeleteMediaAsset = createMutation({
    url: '/media-asset',
    method: 'DELETE',
})
